import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}
  public setToLocalStroage(key: string, value: string) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public getFromLocalStroage(key: string) {
    return localStorage.getItem(key)
      ? JSON.parse(localStorage.getItem(key))
      : null;
  }
  public removeFromLocalStroage(key: string) {
    localStorage.removeItem(key);
  }

  public clearLocalStroge() {
    localStorage.clear();
  }
}
